// ---------------------------------------------------------------------------
// DatalakeAccessDenied — Single source of truth for the "you need a Core
// Identity entitlement" message shown wherever a Data Hub call is refused.
// ---------------------------------------------------------------------------

import { Link, Text } from '@fluentui/react-components';

import {
  DATASET_ENTITLEMENT_NAME_PROD,
  DATASET_ENTITLEMENT_NAME_TEST,
  DATASET_ENTITLEMENT_URL_PROD,
  DATASET_ENTITLEMENT_URL_TEST,
} from '../../../constants/index.js';

import type { DatalakeAccessDeniedProps } from './DatalakeAccessDenied.interface.js';

export function DatalakeAccessDenied({
  action,
  hideTitle,
}: DatalakeAccessDeniedProps) {
  return (
    <>
      {hideTitle !== true && (
        <Text block weight="semibold" size={400}>
          Access denied
        </Text>
      )}
      <Text block size={300}>
        You don&apos;t have permission to {action}. Please apply for the
        appropriate platform role in Core Identity:
      </Text>
      <Text block size={300}>
        For test environment:{' '}
        <Link href={DATASET_ENTITLEMENT_URL_TEST} target="_blank" inline>
          {DATASET_ENTITLEMENT_NAME_TEST}
        </Link>
      </Text>
      <Text block size={300}>
        For SDF/Prod environment:{' '}
        <Link href={DATASET_ENTITLEMENT_URL_PROD} target="_blank" inline>
          {DATASET_ENTITLEMENT_NAME_PROD}
        </Link>
      </Text>
    </>
  );
}
